var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVineMobileMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 4,
  viewBox: "0 0 20 4",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2.5 0C3.327 0 4 .679 4 1.5v1C4 3.327 3.321 4 2.5 4h-1C.673 4 0 3.321 0 2.5v-1C0 .673.679 0 1.5 0zm8 0c.828 0 1.5.679 1.5 1.5v1c0 .828-.679 1.5-1.5 1.5h-1C8.673 4 8 3.321 8 2.5v-1C8 .673 8.679 0 9.5 0zm8 0c.828 0 1.5.679 1.5 1.5v1c0 .828-.679 1.5-1.5 1.5h-1c-.828 0-1.5-.679-1.5-1.5v-1c0-.828.679-1.5 1.5-1.5z"
})));
export default SvgVineMobileMore;